import React, { useMemo } from "react";

import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import CheckBox from "shared/components/CheckBox";
import Space from "shared/components/Space";
import { NAME_SPACES } from "shared/locals/constants";

import { NOTIFICATION_ACCESSORS } from "../constants";

const Component = ({ values, onChange }) => {
  const { t } = useTranslation(NAME_SPACES.ACCOUNT);
  const LABELS = t("NOTIFICATION", { returnObjects: true });

  const isCheckedSms = useMemo(
    () =>
      !!parseInt(
        values.dataList.find(
          (item) => item?.name === NOTIFICATION_ACCESSORS.SMS,
        )?.value || "0",
        10,
      ),
    [values.dataList],
  );
  const isCheckedEmail = useMemo(
    () =>
      !!parseInt(
        values.dataList.find(
          (item) => item?.name === NOTIFICATION_ACCESSORS.EMAIL,
        )?.value || "0",
        10,
      ),
    [values.dataList],
  );

  const onNotificationChange = (field) => () => {
    const notificationValues = {
      [NOTIFICATION_ACCESSORS.SMS]: isCheckedSms,
      [NOTIFICATION_ACCESSORS.EMAIL]: isCheckedEmail,
    };

    const newDataList = [...values.dataList].map((data) => {
      const newData = { ...data };
      if (newData.name === field) {
        newData.value = notificationValues[field] ? "0" : "1";
      }
      return newData;
    });
    onChange({ ...values, dataList: newDataList });
  };

  return (
    <>
      <div className={"col"}>
        <p className={"title"}>{LABELS.TITLE}</p>

        <p>{LABELS.NOTE}</p>
          <Space h={20} />
        <CheckBox
          label={LABELS.SMS}
          onChange={onNotificationChange(NOTIFICATION_ACCESSORS.SMS)}
          value={isCheckedSms}
          checked={isCheckedSms}
        />
        <Space h={12} />
        <CheckBox
          label={LABELS.EMAIL}
          onChange={onNotificationChange(NOTIFICATION_ACCESSORS.EMAIL)}
          value={isCheckedEmail}
          checked={isCheckedEmail}
        />
      </div>
      <Space h={24} />
    </>
  );
};

Component.propTypes = {
  values: PropTypes.shape({
    dataList: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }).isRequired,
    ).isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

Component.defaultProps = {};

export default Component;
